<template>
  <div class="flex flex-col flex-1 gap-2 px-4">
    <div class="font-bold mt-4">
      <template v-if="!isOrigin">
        {{ t(`painting.layout.img`) }}
      </template>
    </div>
    <div
      class="flex justify-center items-center"
      @click="showImgUploadPopup = true"
    >
      <div
        :class="[
          'rounded-lg overflow-hidden flex justify-center items-center border  text-base-content/50 bg-base-200',
          reqData.source ? '' : 'w-full min-h-[10rem]',
        ]"
      >
        <VanImage
          v-if="reqData.source"
          class="max-w-full"
          :src="reqData.source.url!"
          fit="cover"
          crossorigin="anonymous"
        />
        <div v-else>
          <button class="btn btn-xs rounded px-4">
            <!-- 编辑 -->
            {{ t(`painting.${isOrigin ? "origin" : "layout"}.upload`) }}
            <!-- {{ t(`painting.layout.upload`) }} -->
          </button>
        </div>
      </div>
    </div>
    <template v-if="reqData.source">
      <div class="text-center">
        <button
          class="btn btn-primary btn-xs rounded px-4"
          @click="(reqData.source = undefined), (reqData.sourceId = undefined)"
        >
          {{ $t("Buttons.deleteReferenceImage") }}
        </button>
      </div>
      <!-- <div class="font-bold mt-4">
        {{ t(`painting.layout.weight`) }}
      </div>
      <div class="flex justify-between w-full items-center gap-4">
        <div>0.1</div>
        <VanSlider
          v-model="reqData.source.weight"
          :min="0.1"
          :max="1"
          size="sm"
          :step="0.1"
        >
          <template #button>
            <button class="btn btn-circle btn-xs">
              {{ reqData.source.weight }}
            </button>
          </template>
        </VanSlider>
        <div>1</div>
      </div> -->
    </template>
  </div>

  <media-select-popup
    @on-media-selected="onMediaSelected"
    enable-use-avatar
    media-type="img"
    :multiple="false"
    v-model:show="showImgUploadPopup"
    :upload-type="7"
    :max-count="1"
    :enable-crop="true"
    :enable-go-image-gen="false"
    :cropAspectRatio="cropAspectRatio"
    showRatioSelect
    @update:crop-aspect-ratio="onCropAspectRatioChange"
    replace
  />
</template>

<script setup lang="ts">
import { MediaUploadFileItem } from "@/types/component";
import { PropType } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  reqData: {
    type: Object as PropType<MateTrait>,
    required: true,
  },
  isOrigin: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["uploadNsfwImage"]);
const { t } = useI18n();
const showImgUploadPopup = ref(false);

const onMediaSelected = ([media]: MediaUploadFileItem[]) => {
  showImgUploadPopup.value = false;
  props.reqData.source = {
    id: media.mediaId,
    url: media.url!,
  };
  props.reqData.sourceId = media.mediaId;
};

const cropAspectRatio = ref(3 / 4);
const onCropAspectRatioChange = (_ratio: string) => {
  const [w, h] = _ratio.split(":").map(Number);
  cropAspectRatio.value = w / h;
};
</script>
